module.exports = __webpack_public_path__ + "img/new_sympton_icon.7ff6d2f.png";